import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ConditionStatus } from '../../Conditions.constants';

import { getStatusStyles, typographyStyles } from './ConditionStatusChip.styles';

const ConditionStatusChip = ({ status }) => (
  <Box sx={getStatusStyles(status)}>
    <Typography data-truncated sx={typographyStyles} variant="medium12">
      {status}
    </Typography>
  </Box>
);

ConditionStatusChip.propTypes = {
  status: PropTypes.oneOf(Object.values(ConditionStatus)).isRequired,
};

export default memo(ConditionStatusChip);
